import { AlertTriangle, RefreshCw, Home } from 'lucide-react'

export interface FallbackProps {
  error: any
  componentStack?: string | null
  eventId?: string | null
  resetError?: () => void
}

export function SentryErrorFallback({ error, resetError }: FallbackProps) {
  const handleReload = () => {
    window.location.reload()
  }

  const handleGoHome = () => {
    window.location.href = '/admin/dashboard'
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc] px-4 py-8 text-[#1e293b]">
      <div className="w-full max-w-[520px] rounded-[24px] border border-[#e2e8f0] bg-white p-6 sm:p-8 shadow-[0_20px_50px_rgba(15,23,42,0.1)] text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#fef2f2] text-[#ef4444] shadow-xs">
          <AlertTriangle className="h-7 w-7" />
        </div>

        <h1 className="mt-5 text-[22px] font-bold tracking-[-0.02em] text-[#0f172a]">
          Something went wrong
        </h1>

        <p className="mt-2 text-[14px] leading-relaxed text-[#64748b]">
          An unexpected application error occurred. Our team has been automatically notified and is looking into the issue.
        </p>

        {import.meta.env.DEV && error ? (
          <div className="mt-4 overflow-x-auto rounded-xl border border-[#fee2e2] bg-[#fff5f5] p-3 text-left">
            <p className="text-[12px] font-bold text-[#b91c1c]">Developer Stack Trace:</p>
            <pre className="mt-1 text-[11px] font-mono text-[#7f1d1d] whitespace-pre-wrap break-all">
              {error.message || String(error)}
              {error.stack ? `\n\n${error.stack}` : ''}
            </pre>
          </div>
        ) : null}

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={resetError || handleReload}
            className="inline-flex h-11 w-full sm:w-auto items-center justify-center gap-2 rounded-[12px] bg-[#146971] px-5 text-[14px] font-semibold text-white transition hover:bg-[#0f565d] active:scale-[0.98]"
          >
            <RefreshCw className="h-4 w-4" />
            Try Again
          </button>

          <button
            type="button"
            onClick={handleGoHome}
            className="inline-flex h-11 w-full sm:w-auto items-center justify-center gap-2 rounded-[12px] border border-[#d1d5db] bg-white px-5 text-[14px] font-semibold text-[#374151] transition hover:bg-[#f9fafb] active:scale-[0.98]"
          >
            <Home className="h-4 w-4" />
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}

export default SentryErrorFallback
